<template>
  <div class="titleContainer">
    <h3>Layout e Descrição</h3>
    <small>Edite o layout e descrição do curso</small>
</div>
    <div class="config-form-content editCourse">
        <div class="content-wrapper primary">
          <div class="wrapper-inner">
            <div class="content-form">
              <div class="row">

                <div class="col-form-outer col-12 col-md-12 col-lg-12 flex">
                    <div class="col-form-inner col-6 col-md-6 col-lg-6">
                      <div class="form-group">
                          <center>
                            <img :src="imagePreviewThumbnail || imageThumbnail" v-show="imagePreviewThumbnail" style="width: 370px;"/>
                          </center>
                      </div>
      
                    <div class="col-form-inner col-12 col-md-12 col-lg-12" :class="imagePreviewThumbnail || imageThumbnail ? 'hide':''">
                      <div class="form-group">
                        <div class="form-label">
                          <label> Miniatura do Curso </label>
                          <small>Imagem minuatura preview de cada curso</small>
                        </div>
                        <div class="form-file">
                          <div class="file-wrapper primary">
                            <span class="thumbnail thumb-img">
                              <span class="icon">
                                <svg
                                  width="46"
                                  height="39"
                                  viewBox="0 0 46 39"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                    stroke="#9D9FA3"
                                    stroke-width="1.25714"
                                  ></path>
                                  <rect
                                    x="1.00049"
                                    y="1.40454"
                                    width="43.9461"
                                    height="36.1909"
                                    rx="2.58507"
                                    stroke="#9D9FA3"
                                    stroke-width="1.25714"
                                  ></rect>
                                  <circle
                                    cx="14.8948"
                                    cy="10.6676"
                                    r="3.71629"
                                    stroke="#9D9FA3"
                                    stroke-width="1.25714"
                                  ></circle>
                                </svg>
                              </span>
                              <span class="text">
                                Clique aqui para selecionar a imagem
                              </span>
                            </span>
                            <input class="form-control" type="file" @change="updateFilePathThumbnail"   accept=".png, .jpg, .jpeg, .webp"
                            />
                          </div>
                          <div class="form-caption">
                            <div class="caption">
                              <span> Tamanho: 1920x400px. Apenas PNG </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-form-outer col-6 col-md-6 col-lg-6">
                      <div class="form-group">
                        <img :src="imagePreviewBanner" v-show="imagePreviewBanner" />
                      </div>
      
                    <div class="col-form-inner col-12 col-md-12 col-lg-12" :class="imagePreviewThumbnail || imageThumbnail ? 'hide':''">
                      <div class="form-group">
                        <div class="form-label">
                          <label> Banner do Curso </label>
                          <small>Imagem principal do curso</small>
                        </div>
                        <div class="form-file">
                          <div class="file-wrapper primary">
                            <span class="thumbnail thumb-img">
                              <span class="icon">
                                <svg
                                  width="46"
                                  height="39"
                                  viewBox="0 0 46 39"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M45 19.9308L36.7274 12.3475C36.1595 11.827 35.2948 11.8047 34.7009 12.2953L18.824 25.411C18.3196 25.8277 17.6074 25.8812 17.0464 25.5446L11.1009 21.9773C10.5893 21.6703 9.94666 21.6856 9.45024 22.0166L1 27.6501"
                                    stroke="#9D9FA3"
                                    stroke-width="1.25714"
                                  ></path>
                                  <rect
                                    x="1.00049"
                                    y="1.40454"
                                    width="43.9461"
                                    height="36.1909"
                                    rx="2.58507"
                                    stroke="#9D9FA3"
                                    stroke-width="1.25714"
                                  ></rect>
                                  <circle
                                    cx="14.8948"
                                    cy="10.6676"
                                    r="3.71629"
                                    stroke="#9D9FA3"
                                    stroke-width="1.25714"
                                  ></circle>
                                </svg>
                              </span>
                              <span class="text">
                                Clique aqui para selecionar a imagem
                              </span>
                            </span>
                            <input class="form-control" type="file" @change="updateFilePathBanner"    accept=".png, .jpg, .jpeg, .webp"
                            />
                          </div>
                          <div class="form-caption">
                            <div class="caption">
                              <span> Tamanho: 1920x400px. Apenas PNG </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-form-outer col-12 col-md-12 col-lg-12">
                  <div class="row">
                    <div class="col-form-inner col-12 col-md-12 col-lg-12">
                      <div class="form-group">
                        <div class="form-label">
                          <label> Descrição Resumida do Curso  <v-tooltip text="Campo obrigatório" location="top">
                            <template v-slot:activator="{ props }">
                              <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                            </template>
                          </v-tooltip></label>
                        </div>
                        <div class="form-textarea">
                          <QuillEditor theme="snow" toolbar="essential"
                          @input="updateContentShortDescription($event.srcElement.innerHTML)"
                          v-model:content="shortDescription"
                          contentType="html"
                           />
                           <small class="alertText" v-show="showAlerts[9]==true">Campo obrigatório e deve ser preenchido corretamente.</small>
                        </div>
                      </div>
                    </div>
    
                    <div class="col-form-inner col-12 col-md-12 col-lg-12">
                      <div class="form-group">
                        <div class="form-label">
                          <label> Descrição Completa do Curso  <v-tooltip text="Campo obrigatório" location="top">
                            <template v-slot:activator="{ props }">
                              <fa v-bind="props" icon="fa-solid fa-circle-exclamation"></fa>
                            </template>
                          </v-tooltip></label>
                        </div>
                        <div class="form-textarea full-descroption">
                          <QuillEditor theme="snow" toolbar="essential" 
                          @input="updateContentLongDescription($event.srcElement.innerHTML)"
                          v-model:content="longDescription"
                          contentType="html"/>
                          <small class="alertText" v-show="showAlerts[10]==true">Campo obrigatório e deve ser preenchido corretamente.</small>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="actions">
            <button class="btn" @click="(()=>this.$router.push('/admin/colecao/'+this.currentCollections.id))">Cancelar</button>
            <button class="btn" @click="createCourse()">Salvar</button>
      </div>
        </div>
      </div>
      <v-dialog
      v-model="dialog"
      width="auto"
    >
      <v-card
        max-width="400"
        prepend-icon="mdi-update"
        text="Um ou mais campo não foram preenchidos corretamenta, por favore revise-os."
        title="Ops, há algum erro!"
      >
        <template v-slot:actions>
          <v-btn
            class="ms-auto"
            text="Ok"
            @click="dialog = false"
          ></v-btn>
        </template>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import api from '@/utils/courses';
import apiAWS from '@/utils/storage/aws';
import Loader from '@/components/Loader/loader.vue'

export default{
    data(){
        return{
          name:'',
          comercialName:'',
          link:'',
          status:null,
          available:null,
          price:null,
          discount:null,
          certificated:0,
          notaAprovacao:null,
          shortDescription:null,
          longDescription:null,
          imageBanner:null,
          imageThumbnail:null,
          imagePreviewThumbnail:null,
          imagePreviewBanner:null,
          hasReady:false,
          dialog:false,
          activeTab:[true, false],
          showAlerts:[],
          noErros:false,
          windowWidth: window.innerWidth,
        }
    },
    components:{
      Loader
    },
    computed:{
      ...mapState(['token','IdCourse']),
      responsiveClassOne() {
          return this.windowWidth <= 500
            ? 'col-form-outer col-12 col-md-7 col-lg-7'
            : 'col-form-outer col-7 col-md-7 col-lg-7';
        },
        responsiveClassTwo() {
          return this.windowWidth <= 500
            ? 'col-form-inner col-12 col-md-6 col-lg-6'
            : 'col-form-inner col-6 col-md-6 col-lg-6';
        },
        responsiveClassThree() {
          return this.windowWidth <= 500
            ? 'col-form-inner col-12 col-md-6 col-lg-6'
            : 'col-form-inner col-6 col-md-6 col-lg-6';
        },
      mounted() {
        window.addEventListener('resize', this.handleResize);
      },
      beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
      },
    },
    methods:{
      saveEditCourse(){
        this.editCouse();
        setTimeout(this.getDataCourse, 1000);
      },
      changeView(id){
          this.activeTab[id]=!this.activeTab[id];
        },
      updateContentShortDescription(value){
        this.shortDescription=value;
        },
        updateContentLongDescription(value){
        this.longDescription=value;
        },
        async putFileAws(url, file){
          try {
              const response = await apiAWS.putFileAWS(url, file);
          } catch (error) {
              console.error('Erro ao enviar arquivo para AWS');
          }
        },
        async updateFilePath(event){
            const file = event.target.files[0];
            this.imagePreview = URL.createObjectURL(file)

            const formData = new FormData();
            formData.append('file', this.imagePath);

            try {
                const response =  await apiAWS.getSignatureImage(this.token, file.name);
                this.putFileAws(response.url, file)
                this.imagePath = response.token;
                console.debug(response);
            } catch (error) {
                console.error('Erro na geração do TOKEN AWS')
            }
        },
        async getDataCourse(){
            try {
                const response =  await api.getCourse(this.IdCourse, this.token);
                this.name = response.name;
                this.comercialName = response.comercialName;
                this.link =  response.url;
                this.status = response.status;
                this.available = response.dayExpired;
                this.price = response.price;
                this.discount = response.discount;
                this.certificated = response.certificate;
                this.notaAprovacao = response.approved;
                this.longDescription =  response.longDescription;
                this.shortDescription =  response.shortDescription;
                this.imageBanner = response.imagePath;
                this.imageThumbnail = response.imagePath2;
                this.imagePreviewBanner = response.imageFinalPath2;
                this.imagePreviewThumbnail = response.imageFinalPath;
                this.hasReady=true;
            } catch (error) {
                console.error('Erro ao pegar dos dados do curso', error)
            }
        },

        async editCouse() {
        
            let price = this.price;
            let discount = this.discount;
            const obj = {
              "name": this.name,
              "comercialName": this.comercialName,
              "url": this.link, 
              "status": this.status,
              "dayExpired": this.available,
              "price": price.toString().replace(',','.'),
              "discount": discount.toString().replace(',','.'),
              "certificate": this.certificated,
              "approved": this.notaAprovacao, 
              "shortDescription": this.shortDescription,
              "longDescription": this.longDescription, 
              "imagePath":this.imageBanner,
              "imagePath2": this.imageThumbnail,
        };
        Object.entries(obj).forEach(([key, value], index) => {
          this.noErros = false;

        if (value==null || value=='') {
          if (key !== 'certificate' && key !== 'approved') {
                  this.showAlerts[index] = true;
                  this.noErros = true;
              }
            }
        });         
  
        if(this.noErros == true){
          return;
        }
        try {
            const response = await api.editCourse(this.IdCourse, obj, this.token);
            window.location.reload();
        } catch (error) {
            console.error('Erro ao Editar o Curso', error);
        }
    },
        async putFileAws(url, file){
          try {
              const response = await apiAWS.putFileAWS(url, file);
          } catch (error) {
              console.error('Erro ao enviar arquivo para AWS');
          }
        },
        async updateFilePathBanner(event){
            const file = event.target.files[0];
            this.imagePreviewBanner = URL.createObjectURL(file);
            try {
                const response =  await apiAWS.getSignatureImage(this.token, file.name);
                this.putFileAws(response.url, file);
                this.imageBanner = response.token;
                console.debug(response);
            } catch (error) {
                console.error('Erro na geração do TOKEN AWS')
            }
        },
        async updateFilePathThumbnail(event){
            const file = event.target.files[0];
            this.imagePreviewThumbnail = URL.createObjectURL(file);
            try {
                const response =  await apiAWS.getSignatureImage(this.token, file.name);
                this.putFileAws(response.url, file);
                this.imageThumbnail = response.token;
            } catch (error) {
                console.error('Erro na geração do TOKEN AWS')
            }
        },
        formatString() {
          this.comercialName = this.name;

          let formatted = this.name.trim().toLowerCase();

          // Normaliza a string para separar caracteres diacríticos
          formatted = formatted.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

          formatted = formatted.replace(/\s+/g, '-'); 
          formatted = formatted.replace(/[^\w\s-]/g, ''); 

          this.link = '/' + formatted;
        },
    },
    created(){
        this.getDataCourse();
        for (let i = 0; i < 11; i++) {
          this.showAlerts.push(false);
        }
    },
    
}
</script>

<style>
@import './tabs.css';
small.alertText {
  color: red;
  font-size: 11px;
}
.dashboard.dark small.alertText {
  color: #ffa2a2;
  font-size: 11px;
}
 
.editCourse .ql-editor {
  min-height: 120px !important;
}
.config-form.primary {
  background-color: rgb(255, 255, 255);
  border-radius: 0px 0px 0.5em 0.5em;
  padding: 10px;
}
.col-form-outer.col-12.col-md-12.col-lg-12{
  padding: 0;
}
</style>
<style scoped>
.titleContainer {
  display: block;
  text-align: left;
  padding: 0!important;
  border-bottom: 1px solid #e8e8e8;
  margin: 0px!important;
  margin-bottom: 10px;
  padding-bottom: 10px;
}
</style>